import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";

/** Spaces (rooms, open areas, corridors) of a floor's active map, or of one map version. */
export const useFloorSpacesQuery = (
  floorId: string | null,
  mapId?: string | null
) => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: [
      "useFloorSpacesQuery",
      apiClient.slug,
      floorId ?? "",
      mapId ?? ""
    ],
    queryFn: async () => {
      const res = await apiClient.zones.floorSpaces(
        floorId ?? "",
        mapId ?? undefined
      );
      return res.result;
    },
    enabled: !!apiClient.slug && !!floorId
  });
};

export const useResourcePlacementQuery = (resourceId: string | null) => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: ["useResourcePlacementQuery", apiClient.slug, resourceId ?? ""],
    queryFn: async () => {
      const res = await apiClient.zones.placement(resourceId ?? "");
      return res.result;
    },
    enabled: !!apiClient.slug && !!resourceId
  });
};
